import React from "react";
import "./Note.css";

const Note = () => {
  return (
    <div className="note-container">
      <h2>My favorite poem of all time by Bessie Anderson Stanley</h2>
      <h3>Success</h3>
      <p>
        He has achieved success
        <br />
        Who has lived well,
        <br />
        laughed often, and loved much;
        <br />
        Who has enjoyed the trust of pure women,
        <br />
        The respect of intelligent men and
        <br />
        The love of pure children;
        <br />
        Who has filled his niche and accomplished his task;
        <br />
        Who has left the world better than he found it
        <br />
        Whether by an improved poppy,
        <br />
        A perfect poem or a rescued soul;
        <br />
        Who has never lacked appreciation of Earth's beauty or failed to express
        it;
        <br />
        Who has always looked for the best in others and
        <br />
        Given them the best he had;
        <br />
        Whose life was an inspiration;
        <br />
        Whose memory a benediction.
        <br />
      </p>
    </div>
  );
};

export default Note;
